import React, {useContext, useEffect} from 'react'
import {Form, Input, AutoComplete, Select} from "antd";
import {PurchaseContext} from "../../../context/PurchaseContext";

const {Option: SelectOption} = Select

const PurchaseInfos = ({isComplete = false, handleRecipeSelection}) => {
    const [form] = Form.useForm()
    const {purchaseInfos: topInfo, recipes} = useContext(PurchaseContext)
    const [recipeData] = recipes
    const [purchaseInfos, setPurchaseInfos] = topInfo

    useEffect(() => {
        form.setFieldsValue({
            delivery: purchaseInfos.delivery || '',
            payment: purchaseInfos.payment || '',
            currency: purchaseInfos.exchangeRate || '',
            whom: purchaseInfos.whom || ''
        })
    }, [purchaseInfos])

    const onRecipeSelectionChange = (v, selectedOptions) => {
        if (selectedOptions.length) handleRecipeSelection(selectedOptions)
    }
    const handleChange = (changedValue) => {
        const [key, value] = Object.entries(changedValue)[0]
        switch (key) {
            case 'delivery':
                setPurchaseInfos((oldState) => {
                    return {...oldState, delivery: value}
                })
                break
            case 'payment':
                setPurchaseInfos((oldState) => {
                    return {...oldState, payment: value}
                })
                break
            case 'currency':
                setPurchaseInfos((oldState) => {
                    return {...oldState, exchangeRate: value}
                })
                break
            case 'whom':
                setPurchaseInfos((oldState) => {
                    return {...oldState, whom: value}
                })
                break
        }
    }

    return (
        <React.Fragment>
            <Form
                form={form}
                name={'purchase-create-infos'}
                onValuesChange={handleChange}
                labelAlign={'left'}
                labelCol={{span: 6}}
                wrapperCol={{span: 8}}
            >
                {
                    isComplete
                        ?
                            <Form.Item
                                name={'recipe'}
                                label={'Reçete'}
                            >
                                <Select mode={'multiple'} onChange={onRecipeSelectionChange}>
                                    {
                                        recipeData.map(item => {
                                            return <SelectOption key={item.id} value={item.name}>{item.name}</SelectOption>
                                        })
                                    }
                                </Select>
                            </Form.Item>
                        : null
                }
                <Form.Item
                    name={'delivery'}
                    label={'Teslimat'}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    name={'currency'}
                    label={'Kur Bilgisi'}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    name={'payment'}
                    label={'Ödeme'}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    name={'whom'}
                    label={'Kime'}
                >
                    <Input/>
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default PurchaseInfos